'use strict';

var chartsConfig = require('../config/MarketAnalysisThematicChartsDirectiveConfig');
var _ = require('lodash');
var MarketAnalysisThematicChartsController = function MarketAnalysisThematicChartsController($scope, featureToggleService) {
  function isAvaliable(configuration) {
    //check the feature
    if (configuration.showIfFeature && featureToggleService.isDisabled(configuration.showIfFeature) || configuration.hideIfFeature && featureToggleService.isEnabled(configuration.hideIfFeature)) {
      return false;
    }
    return true;
  }
  $scope.charts = _.transform(chartsConfig[$scope.mode], function (result, entry) {
    if (isAvaliable(entry)) {
      entry.mode = $scope.mode;
      result.push(entry);
    }
  });
  if ($scope.mode === 'market-product-group') {
    $scope.metrics = {
      metricList: [{
        id: 'booking',
        label: 'Bookings',
        chartType: 'profile-chart'
      }, {
        id: 'revenue',
        label: 'Revenue',
        chartType: 'profile-chart'
      }]
    };
    if (featureToggleService.isEnabled('COMPFARE_AVAILABILITY')) {
      $scope.metrics.metricList.push({
        id: 'competitor',
        label: 'Comp Fares',
        chartType: 'competitor-fares-chart'
      });
    }
    $scope.metrics.selectedMetric = $scope.metrics.metricList[0];
  }
  function setVisibility(chartType) {
    var chart = _.find($scope.charts, {
      'type': chartType
    });
    if (!chart) {
      return false;
    }
    var previousState = chart.visible;
    chart.visible = $scope.oneDaySelected && $scope.oneMarketSelected;
    if ($scope.metrics) {
      chart.visible = chart.visible && $scope.metrics.selectedMetric.chartType === chartType;
    }
    return chart.visible !== previousState;
  }

  /**
   * This function is for MA - Service Tab, this is for setting oneMarketSelected to true if the passed boolean
   * is true, otherwise oneMarketSelected will be false
   * @param eventName
   * @param setOneMarketSelected
   */
  $scope.isOneMarketSelectedForServiceTab = function (eventName, setOneMarketSelected) {
    if (eventName === 'service-analysis:oneDaySelected') {
      $scope.oneMarketSelected = setOneMarketSelected ? true : false;
    }
  };
  $scope.isChartVisible = function (chartType, expectedChartType) {
    return chartType === expectedChartType;
  };
  $scope.oneMarketSelectedHandler = function (event, isOneMarketSelected) {
    $scope.oneMarketSelected = isOneMarketSelected;
    $scope.changeVisibility();
  };
  $scope.changeVisibility = function () {
    var refreshProfile = setVisibility('profile-chart');
    var refreshCompetitor = setVisibility('competitor-fares-chart');
    if (refreshProfile || refreshCompetitor) {
      $scope.$broadcast('reload-carousel');
    }
  };
};
MarketAnalysisThematicChartsController.$inject = ['$scope', 'FeatureToggleService'];
module.exports = MarketAnalysisThematicChartsController;